import React, { useState, useEffect } from "react";
import { Modal, Input, Checkbox, Button } from "antd";

const { Search } = Input;

const SearchProductsModal = ({
  open,
  onClose,
  categoryData,
  productData,
  type,
  existingProducts,
}) => {
  const [searchText, setSearchText] = useState("");
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [filteredMenu, setFilteredMenu] = useState([]);

  useEffect(() => {
    // Fetch categories and products from the database (assuming you have functions for this)
    // const fetchedCategories = [];
    console.log(categoryData);

    // Add a special category
    const specialCategory = { id: 0, categoryName: "Special Category" };
    if (!categoryData.some((category) => category.id === specialCategory.id)) {
      categoryData.unshift(specialCategory);
    } else {
      const specialCategoryIndex = categoryData.findIndex(
        (category) => category.id === specialCategory.id
      );
      categoryData.splice(specialCategoryIndex, 1);
      categoryData.unshift(specialCategory);
    }

    // Add special products
    const specialProduct1 = {
      productName: "Free Delivery",
      productCategoryId: 0,
    };
    // const specialProduct2 = {
    //   productName: "Special Product 2",
    //   productCategoryId: 0,
    // };

    if (!productData.some((product) => product.id === specialProduct1.id)) {
      productData.push(specialProduct1);
    }

    // Filter out products that already exist in existingProducts
    const filteredFetchedProducts = productData.filter(
      (product) =>
        !existingProducts.some(
          (existingProduct) =>
            existingProduct.productName === product.productName
        )
    );

    // Initialize the filteredMenu state with the entire menu
    const entireMenu = categoryData.map((displayedCategory) => ({
      id: displayedCategory.id,
      categoryName: displayedCategory.categoryName,
      items: filteredFetchedProducts.filter(
        (product) => product.productCategoryId === displayedCategory.id
      ),
    }));
    setFilteredMenu(entireMenu);

    // Retrieve selected items and categories from sessionStorage
    const storedSelectedItems = sessionStorage.getItem(
      `selectedItems_${type}`
    );
    // const storedSelectedCategories =
    //   sessionStorage.getItem("selectedCategories");

    // Parse stored data and set state
    if (storedSelectedItems) {
        console.log(`selectedItems_${type}`);
      setSelectedItems(JSON.parse(storedSelectedItems));
    }

    // if (storedSelectedCategories) {
    //   setSelectedCategories(JSON.parse(storedSelectedCategories));
    // }
  }, [existingProducts]);

  //   useEffect(() => {
  //     // Initialize the filteredMenu state with the entire menu
  //     const entireMenu = categoryData.map((displayedCategory) => ({
  //       id: displayedCategory.id,
  //       categoryName: displayedCategory.categoryName,
  //       items: productData.filter(
  //         (product) => product.productCategoryId === displayedCategory.id
  //       ),
  //     }));
  //     setFilteredMenu(entireMenu);
  //   }, []);

  useEffect(() => {
    console.log(type);
    setSelectedItems([]);
  }, [type]);

  const filterMenu = () => {
    const lowerCaseSearchText = searchText.toLowerCase();

    if (lowerCaseSearchText) {
      // Show only categories and items that contain the search keyword
      const filteredMenu = categoryData
        .filter(({ categoryName }) =>
          categoryName.toLowerCase().includes(lowerCaseSearchText)
        )
        .map((displayedCategory) => ({
          id: displayedCategory.id,
          categoryName: displayedCategory.categoryName,
          items: productData
            .filter(
              (product) => product.productCategoryId === displayedCategory.id
            )
            .filter(({ productName }) =>
              productName.toLowerCase().includes(lowerCaseSearchText)
            ),
        }));

      setFilteredMenu(filteredMenu);
    } else {
      // If no search keyword, show the entire menu
      const entireMenu = categoryData.map((displayedCategory) => ({
        id: displayedCategory.id,
        categoryName: displayedCategory.categoryName,
        items: productData.filter(
          (product) => product.productCategoryId === displayedCategory.id
        ),
      }));
      setFilteredMenu(entireMenu);
    }
  };

  const handleCheckboxChange = (item, isCategory) => {
    // if (isCategory) {
    //   const isSelected = selectedCategories.some(
    //     (category) => category.id === item.id
    //   );

    //   // Toggle the selected state of the category
    //   const newSelectedCategories = isSelected
    //     ? selectedCategories.filter((category) => category.id !== item.id)
    //     : [...selectedCategories, item];

    //   setSelectedCategories(newSelectedCategories);

    //   // Automatically select or deselect all products under the category
    //   const productsUnderCategory = productData.filter(
    //     (product) => product.productCategoryId === item.id
    //   );
    //   const newSelectedItems = isSelected
    //     ? selectedItems.filter(
    //         (selectedItem) =>
    //           !productsUnderCategory.some(
    //             (product) => product.productName === selectedItem.productName
    //           )
    //       )
    //     : [
    //         ...selectedItems,
    //         ...productsUnderCategory.filter(
    //           (product) =>
    //             !selectedItems.some(
    //               (selectedItem) =>
    //                 selectedItem.productName === product.productName
    //             )
    //         ),
    //       ];

    //   setSelectedItems(newSelectedItems);
    // } else {
    // Handle individual product checkbox change
    const isSelected = selectedItems.some(
      (selectedItem) => selectedItem.productName === item.productName
    );
    const newSelectedItems = isSelected
      ? selectedItems.filter(
          (selectedItem) => selectedItem.productName !== item.productName
        )
      : [...selectedItems, item];

    setSelectedItems(newSelectedItems);

    sessionStorage.setItem(
      `selectedItems_${type}`,
      JSON.stringify(newSelectedItems)
    );
    // sessionStorage.setItem("selectedItems", {type: type, data: JSON.stringify(newSelectedItems)});
    //   sessionStorage.setItem(
    //     "selectedCategories",
    //     JSON.stringify(newSelectedCategories)
    //   );
    // }
  };

  const saveSelectedItems = () => {
    // Combine selected categories and items
    const itemsForSelectedCategories = selectedCategories.flatMap(
      (selectedCategory) =>
        productData.filter(
          (product) => product.productCategoryId === selectedCategory.id
        )
    );

    const allSelectedItems = [...selectedItems, ...itemsForSelectedCategories];

    sessionStorage.setItem(type, JSON.stringify(allSelectedItems));
    var promoProductData = [];
      if (type === "BuyX" || type === "GetY"){
        var buyData = convertData(
          JSON.parse(sessionStorage.getItem("BuyX")) || [],
          "BuyProductCode"
        );
        var getData = convertData(
          JSON.parse(sessionStorage.getItem("GetY")) || [],
          "GetProductCode"
        );
        promoProductData = buyData.concat(getData);
    }
    else{
        promoProductData = convertData(allSelectedItems, "BuyProductCode");
    }
    sessionStorage.setItem("promoData", JSON.stringify(promoProductData));
    handleCancel();
  };
  
  const convertData = (data, promotype) => {
    var convertedData = data.map((product) => {
        const convertedProduct = {};
        convertedProduct[promotype] = product.productCode;
      return convertedProduct;
    });
    return convertedData;
  };

  const handleCancel = () => {
    setSelectedItems([]);
    setSelectedCategories([]);
    // onCancel();
    onClose();
  };

  return (
    <Modal
      open={open}
      title=""
      closable={false}
      footer={null}
      onCancel={handleCancel}
    >
      <div
        style={{
          marginBottom: 16,
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Button onClick={onClose}>Close</Button>
        <Button type="primary" onClick={saveSelectedItems}>
          Done
        </Button>
      </div>

      <h2>Add Item</h2>

      <Search
        placeholder="Search for a dish..."
        onChange={(e) => setSearchText(e.target.value)}
        onKeyUp={filterMenu} // Trigger filterMenu on key up
      />

      <div>
        {filteredMenu.map(({ id, categoryName, items }) => (
          <div key={id}>
            {/* <Checkbox
              onChange={() => handleCheckboxChange({ id, categoryName }, true)}
              checked={selectedCategories.some(
                (category) => category.id === id
              )}
            > */}
            <h3>{categoryName}</h3>
            {/* </Checkbox> */}
            <div>
              {items.map(({ productName, ...rest }) => (
                <Checkbox
                  key={productName}
                  onChange={() =>
                    handleCheckboxChange({ productName, ...rest }, false)
                  }
                  checked={selectedItems.some(
                    (item) => item.productName === productName
                  )}
                >
                  {productName}
                </Checkbox>
              ))}
            </div>
            <hr />
          </div>
        ))}
      </div>
    </Modal>
  );
};

export default SearchProductsModal;
